class App {
  constructor() {
    this.preDefinedApps = {}
  }
  _init = async () => {
    return true
  }
  getList = async () => {
    return []
  }

  launch = async () => {
    return true
  }
  close = async () => {
    return true
  }
}

export default App
